export const name = 'lightboxService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-lightbox' as const
